import { createContext, useContext } from "react";

const ModalStageContext = createContext();
export const useModalStageContext = () => useContext(ModalStageContext);
export default ModalStageContext;
